import { Component } from '@angular/core';

interface ErrorRow {
  status: number;
  code: string;
  meaning: string;
}

/** The standard HTTP reason phrase for each status in the list below. */
const REASONS: Record<number, string> = {
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  429: 'Too Many Requests',
  502: 'Bad Gateway',
};

/**
 * Errors guide (/docs/errors) the shared error envelope and the status/
 * code table. Split out of the old single /docs mega-page (see
 * docs/overview/docs.ts) so it has its own route.
 */
@Component({
  selector: 'app-docs-errors',
  standalone: false,
  templateUrl: './docs-errors.html',
})
export class DocsErrors {
  /** The envelope's shape: field names only, no made-up values. */
  readonly envelope = `{
  "error": {
    "code": "…",
    "message": "…",
    "details": { … }
  }
}`;

  reasonOf(status: number): string {
    return REASONS[status] ?? '';
  }

  readonly errors: ErrorRow[] = [
    { status: 401, code: 'missing_api_key', meaning: 'No Authorization header.' },
    { status: 401, code: 'invalid_api_key', meaning: 'Unknown or revoked key. Revoked and never-existed give the same answer on purpose.' },
    { status: 402, code: 'insufficient_funds', meaning: 'The balance will not cover the call. details carries the balance and the amount required.' },
    { status: 403, code: 'focus_required', meaning: 'The endpoint needs a FOCUS entitlement your organization does not have.' },
    { status: 404, code: 'unknown_endpoint', meaning: 'Not a published path. The surface is an allow-list, not a passthrough.' },
    { status: 429, code: 'rate_limit_exceeded', meaning: 'Over 60 requests in a minute for this key.' },
    { status: 502, code: 'upstream_unavailable', meaning: 'The index could not be reached. Retry shortly.' },
  ];
}
